import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}
const callConnectionDateSlice = createSlice({
    name:'callConnectionDate',
    initialState,
    reducers:{
        addCallConnectionDate: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        },
        largeVideoUserReducer: (_state,payload)=>{
            return {
             "id" : uuidv4(),
             "data": payload.payload
            }
     }
    }
});

export default callConnectionDateSlice.reducer
export const addCallConnectionDate = callConnectionDateSlice.actions.addCallConnectionDate
export const largeVideoUserReducer = callConnectionDateSlice.actions.largeVideoUserReducer